export default __webpack_public_path__ + "static/media/4.03a5f157.svg";